import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-survey')
  .service(
    'updateSurveyRecipientTrackingCommand',
    ($http: ng.IHttpService, defineCommandORM: IDefineCommand, accountModel: AccountModel, log: any) => {
      return defineCommandORM(
        'updateSurveyRecipientTrackingCommand',
        (deferred: ng.IDeferred<object>, surveyID: string, methodType: string, methodXRecipientID) => {
          $http
            .put(`students/${accountModel.student_id}/surveys/${surveyID}/${methodType}/${methodXRecipientID}`, {
              clicked: true
            })
            .then(({ data }: { data: object }) => {
              deferred.resolve(data);
            })
            .catch((error) => {
              log.issue('Failed to update survey tracking info!');
              deferred.reject(error);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/commands/update_survey_recipient_tracking_command.ts